export const last = (value: string, separator: string): string | undefined => {
  const values = value.split(separator)
  return values?.[values?.length - 1]
}

export default last
